module.exports = __webpack_public_path__ + "static/media/calendar-hollow.565c4d8f.svg";